import { CommonModule } from '@angular/common';
import { NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { UiElementsModule } from '@boma/ui-elements';
import player from 'lottie-web';
import { GetFirstAvailableImageForSizePipe } from './pipes/show-entity-image.pipe';
import { LottieModule } from 'ngx-lottie';
import { WebsiteFooterComponent } from './website-footer/website-footer.component';
import { WebsiteMenuComponent } from './website-menu/website-menu.component';
import { SearchFacetComponent } from './search-facet/search-facet.component';
import { AnimProductSearchComponent } from './boma-anim-product-search/boma-anim-product-search.component';
import { BomaSpinningLoaderComponent } from './boma-spinning-loader/boma-spinning-loader.component';
import { BomaAnimationComponent } from './boma-animation/boma-animation.component';
import { BomaHeaderBannerComponent } from './boma-download-app/boma-header-banner.component';
import { RippleModule } from 'primeng/ripple';
import { InteractiveCardComponent } from './interactive-card/interactive-card.component';
import { BomaPaymentGatewayComponent } from './boma-payment-gateway/boma-payment-gateway.component';
import { GoogleMapsModule } from '@angular/google-maps';
import { BomaUpdateLocationComponent } from './boma-update-location/boma-update-location';
import { NotificationsModule } from '@boma/libs/shared/modules';

export function playerFactory() {
  return player;
}

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    UiElementsModule,
    LottieModule,
    GoogleMapsModule,
    // AgmCoreModule.forRoot({
    //   apiKey: 'AIzaSyCqP9GtDyRnHbq9JrQeGWV87uuGpxtsRuc',
    //   libraries: ['places', 'drawing', 'geometry'],
    // }),
    LottieModule.forRoot({ player: playerFactory }),
    RippleModule,
    NotificationsModule,
  ],
  declarations: [
    WebsiteMenuComponent,
    WebsiteFooterComponent,
    BomaSpinningLoaderComponent,
    SearchFacetComponent,
    AnimProductSearchComponent,
    BomaAnimationComponent,
    GetFirstAvailableImageForSizePipe,
    BomaHeaderBannerComponent,
    BomaUpdateLocationComponent,
    InteractiveCardComponent,
    BomaPaymentGatewayComponent,
  ],
  providers: [],
  exports: [
    WebsiteMenuComponent,
    WebsiteFooterComponent,
    BomaSpinningLoaderComponent,
    SearchFacetComponent,
    AnimProductSearchComponent,
    BomaAnimationComponent,
    BomaHeaderBannerComponent,
    BomaPaymentGatewayComponent,
    GetFirstAvailableImageForSizePipe,
    InteractiveCardComponent,
    BomaUpdateLocationComponent,
  ],
  schemas: [NO_ERRORS_SCHEMA],
})
export class WebsiteSharedUiModule {}
